// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8573) return "static/chunks/8573-6266937737792a69.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4730":"8c7c17cd345d503c","8042":"c4b8e0fb82308987"}[chunkId] + ".js";
};